import React from 'react';
import type { QueryMode } from '../../types';

export interface HeaderProps {
  queryMode: QueryMode;
  onQueryModeChange: (mode: QueryMode) => void;
}

export function Header(props: HeaderProps): React.ReactElement {
  const { queryMode, onQueryModeChange } = props;

  return (
    <header className="dash-title-bar">
      <h1 className="dash-title-bar__text">市场营销数字化管理平台</h1>
      <div className="dash-title-bar__controls">
        <button
          type="button"
          className={
            queryMode === 'projects'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('projects')}
        >
          项目查询
        </button>
        <button
          type="button"
          className={
            queryMode === 'docking'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('docking')}
        >
          对接记录
        </button>
        <button
          type="button"
          className={
            queryMode === 'progress'
              ? 'dash-mode-switch__btn dash-mode-switch__btn--active'
              : 'dash-mode-switch__btn'
          }
          onClick={() => onQueryModeChange('progress')}
        >
          工作进展
        </button>
      </div>
    </header>
  );
}
